export const GOVGR_TABLE = "govgr-table";
export const GOVGR_TABLE__LIGHT = "govgr-table--light";
export const GOVGR_TABLE__CAPTION__M = "govgr-table__caption--m";
export const GOVGR_TABLE__CAPTION = "govgr-table__caption";
export const GOVGR_TABLE__HEAD = "govgr-table__head";
export const GOVGR_TABLE__HEADER = "govgr-table__header";
export const GOVGR_TABLE__BODY = "govgr-table__body";
export const GOVGR_TABLE__ROW = "govgr-table__row";
export const GOVGR_TABLE__CELL = "govgr-table__cell";
